import { twMerge } from 'tailwind-merge';

const CardBodyPredictDeliveryDate = props => {
  const { data, className } = props;
  const { predict_delivery_date_ui } = data || {};
  if (!predict_delivery_date_ui) {
    return null;
  }
  return (
    <div className={twMerge('text-surface-100-fg-minor enki-body-2xs-medium line-clamp-1', className)}>
      {predict_delivery_date_ui}
    </div>
  );
};

export default CardBodyPredictDeliveryDate;
